import Typography from "@material-ui/core/Typography";
import React from "react";
import AppBar from "@material-ui/core/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import ListItemText from "@material-ui/core/ListItemText";
import AliceCarousel from "react-alice-carousel";
import Paper from "@material-ui/core/Paper";
import {BASE_URL, BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {CardShopRepository} from "../Repository/CardShopRepository";
import {Snackbar} from "@material-ui/core";
import MuiAlert from "@mui/material/Alert";
import {BasketComponent} from "./BasketComponent";
import {styled} from "@mui/material/styles";
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import BottomNavigation from "@mui/material/BottomNavigation";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import IconButton from "@mui/material/IconButton";
import {Link} from "react-router-dom";
import {BackButton,FormPropsTextFields} from './HookUtils'

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export class ProductDetailComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            product: {},
            market: {},
            pics: [],
            openSnackbar: false,
            message: "",
            snackbarType: "success",
            updateBasket: Math.random(),
        }
    }

    componentDidMount() {
        fetch(BASE_URL_API + 'product/' + this.props.id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    this.setState({product: results.data, pics: results.data.pictures, market: results.data.markets})
                },
                (error) => {
                    console.log("error")
                }
            );
    }

    render() {
        const onAddToCardClicked = (e) => {

            let findCardShop = CardShopRepository.getItem(this.state.product.id)

            if (findCardShop) {

                let totalEntity = parseInt(findCardShop.count)
                if (totalEntity < parseInt(this.state.product.step)) {
                    if (this.state.product.price>0){
                        CardShopRepository.addCardShop(this.state.product)

                        this.setState({openSnackbar: true, message: "کالا با موفقیت به سبد خرید اضافه شد."})

                        this.setState({"updateBasket":Math.random()})
                    }else {
                        this.setState({openSnackbar: true, message: "جهت خرید کالا تماس بگیرید.", snackbarType: "error"})
                    }

                } else {
                    this.setState({openSnackbar: true, message: "موجودی کالا به اتمام رسیده!", snackbarType: "error"})

                }
            } else if (this.state.product.step > 0) {
                if (this.state.product.price>0){
                    CardShopRepository.addCardShop(this.state.product)

                    this.setState({"updateBasket":Math.random()})
                    this.setState({openSnackbar: true, message: "کالا با موفقیت به سبد خرید اضافه شد."})
                }else {
                    this.setState({openSnackbar: true, message: "جهت خرید کالا تماس بگیرید.", snackbarType: "error"})
                }

            } else {
                this.setState({openSnackbar: true, message: "موجودی کالا به اتمام رسیده!", snackbarType: "error"})
            }

        };

        const handleCloseSnackbar = (e) => {
            this.setState({openSnackbar: false})
        }
        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <ListItemText align="center"><strong style={{
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }} >{this.state.product.title}</strong></ListItemText>

                        <IconButton  style={{ color: 'black' }} >  <BasketComponent key={this.state.updateBasket}/></IconButton>

                        <BackButton/>
                    </ToolbarMui>

                </AppBar>


                <Grid container justify="flex-start" style={{marginTop: 90}}>

                    <Grid tem xs={12} sm={6} md={6} lg={7} order={{xs: 3, sm: 2}}>
                        <AliceCarousel autoPlay
                                       autoPlayStrategy="none"
                                       autoPlayInterval={2500}
                                       animationDuration={1000}
                                       infinite
                                       touchTracking={false}
                                       disableButtonsControls>
                            {this.state.pics.map((picture, index) => (



                                    <div style={{width: '100%', justifyContent: 'center', alignItems: 'center'}}
                                         align='center'>
                                        <img style={{width: 350, height: 350,objectFit: 'cover'}}
                                             src={PRODUCT_BASE_URL_API + picture.url}/>
                                    </div>

                            ))}
                        </AliceCarousel>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={5} style={{padding: 4}}>

                        <div align='center' >
                            <Paper style={{padding: 16}}>
                                <Typography style={{
                                    fontWeight: 'bold',
                                    fontSize: 20,
                                    paddingRight: 20
                                }}>{"نام محصول: " + this.state.product.title}</Typography>

                                <Typography style={{
                                    fontWeight: 'bold',
                                    fontSize: 20,
                                    paddingRight: 20,
                                    marginTop: 40
                                }}>{"فروشگاه: " + this.state.market.name}</Typography>

                                {
                                    this.state.product.del_price > 0 ? (

                                            <Grid container style={{marginTop: 16}}>
                                                <Grid xs={4} justifyContent='center' alignItems='center'>
                                                    <Typography style={{
                                                        marginTop: 35,
                                                        fontWeight: 'bold',
                                                        fontSize: 18,
                                                        color: 'gray',
                                                        height: 100,
                                                    }} align='center'>{"قیمت: "}</Typography>
                                                </Grid>

                                                <Grid xs={8}>
                                                    <React.Fragment>
                                                        <Typography style={{
                                                            fontWeight: 'bold',
                                                            fontSize: 16,
                                                            color: 'gray',
                                                            marginTop: 20,
                                                            textDecorationLine: 'line-through'

                                                        }}>{(this.state.product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + " تومان "}</Typography>
                                                        <Typography style={{
                                                            fontWeight: 'bold',
                                                            fontSize: 18,
                                                            color: 'green',
                                                            marginTop: 20
                                                        }}>{((this.state.product.price - (this.state.product.del_price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان ")}</Typography>
                                                    </React.Fragment>
                                                </Grid>
                                            </Grid>) :

                                        <Typography style={{
                                            fontWeight: 'bold',
                                            fontSize: 20,
                                            color: 'green',
                                            paddingRight: 20,
                                            marginTop: 20
                                        }}>{`قیمت: ${this.state.product.price > 0 ? this.state.product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +` تومان ` : `تماس بگیرید.`}`}</Typography>


                                }


                                <Grid item xs={12}>

                                    <Button onClick={() => onAddToCardClicked()} variant="contained" style={{
                                        marginTop:45,
                                        width: '50%',
                                        color: 'white',
                                        background: "green"
                                    }}
                                            align='right'>{"سفارش محصول"}</Button>
                                </Grid>

                            </Paper>

                        </div>

                    </Grid>

                    <Grid xs={12}>
                        <Typography style={{
                            paddingRight: 20,
                            marginTop: 15,
                            fontWeight: 'bold',
                            fontSize: 20
                        }}>توضیحات</Typography>
                        <Typography style={{
                            padding: 16,
                            paddingRight: 20,
                            paddingBottom: 100,
                            whiteSpace: 'pre-line',
                            wordWrap: "break-word"
                        }}>{this.state.product.des}</Typography>
                    </Grid>


                </Grid>
                <Snackbar open={this.state.openSnackbar} autoHideDuration={3000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType} sx={{width: '100%'}}>
                        {this.state.message}
                    </Alert>
                </Snackbar>

                <FormPropsTextFields/>

            </React.Fragment>
        );
    }


}
